// REACT_APP_API_URL is a bare host in production (e.g. api.example.com) but a
// full URL with protocol in local dev (e.g. http://localhost:8080). Only prepend
// https:// when no protocol is already present, so a local http gateway works
// without forcing TLS (which would otherwise produce https://http://localhost...).
const apiHost = (process.env.REACT_APP_API_URL ?? '').trim();
const apiOrigin = /^https?:\/\//.test(apiHost) ? apiHost : `https://${apiHost}`;

export const apiBaseUrl = `${apiOrigin}/api/`;
